import { Menu, createStyles } from "@mantine/core";
import { Link } from "react-router-dom";
import { useState } from "react";
import HamburgerButton from "./HamburgerButton";

const useStyles = createStyles((theme) => ({
  item: {
    "&[data-hovered]": {
      backgroundColor: theme.colors.orange[1],
      color: theme.colors.orange[9],
    },
  },
}));

const menuItems = [
  { to: "/home", label: "首頁" },
  { to: "/product?category=fresh", label: "鮮果" },
  { to: "/product?category=frozen", label: "急凍產品" },
  { to: "/product", label: "全部產品" },
  { to: "/contact", label: "查詢訂銷" },
];

export default function Dropdown() {
  const [opened, setOpened] = useState(false);
  const { classes } = useStyles();

  return (
    <Menu classNames={classes} shadow="md" width={220} radius="lg" position="bottom-end" zIndex={200}>
      <Menu.Target>
        <HamburgerButton opened={opened} onClick={() => setOpened((o) => !o)} size="lg" color="orange" />
      </Menu.Target>
      <Menu.Dropdown>
        {menuItems.map((item) => (
          <Menu.Item key={item.to} component={Link} to={item.to} onClick={() => setOpened(false)}>
            {item.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
